import { render, staticRenderFns } from "./addPerson.vue?vue&type=template&id=32d925f0&"
import script from "./addPerson.vue?vue&type=script&lang=js&"
export * from "./addPerson.vue?vue&type=script&lang=js&"
import style0 from "./addPerson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports